import { formatPrice, Product } from '../api';

export default function ProductCard({ product, onSelect, delay = 0 }: { product: Product; onSelect: (p: Product) => void; delay?: number }) {
  return (
    <div className={`card-item product-card${product.highlighted ? ' highlighted' : ''}`} data-aos="fade-up" data-aos-delay={delay}>
      {product.highlighted && <div className="ribbon"><span className="tag">Most popular</span></div>}
      <h3>{product.name}</h3>
      <p className="card-text">{product.tagline}</p>
      <div className="price">
        {product.priceFrom && <small style={{ marginLeft: 0, marginRight: '0.35rem' }}>from</small>}
        {formatPrice(product.priceOre)}
        {product.priceOre > 0 && <small>/ {product.billingPeriod === 'month' ? 'month' : 'year'}</small>}
      </div>
      <ul>
        {product.features.map(feature => <li key={feature}>{feature}</li>)}
      </ul>
      <button className="btn-submit" onClick={() => onSelect(product)}>Select {product.name}</button>
    </div>
  );
}
